export const GET_MAPPING_MASTER_LIST = "GET_MAPPING_MASTER_LIST"
export const GET_MAPPING_MASTER_LIST_SUCCESS = "GET_MAPPING_MASTER_LIST_SUCCESS"

export const SAVE_MAPPING_MASTER = "SAVE_MAPPING_MASTER"
export const SAVE_MAPPING_MASTER_SUCCESS = "SAVE_MAPPING_MASTER_SUCCESS"

export const MAPPING_MASTER_API_ERROR = "MAPPING_MASTER_API_ERROR"